(ns com.theplantscape.plant-web.draw.state
  (:require
   [clojure.data]
   [reagent.core :as r]))

(def default-mode :insert)

(def tools {:path {:multi :many}
            :default {:multi :one}
            :tree {:multi :one}
            :ruler {:multi :two}
            :patch {:multi :many}
            :area {:multi :many}
            :structure {:multi :many}})

;;"Mainly for routing"
(defonce site-page
  (r/atom {}))


(defonce site-data
  (r/atom {:plant-types [:canopy :sub-canopy :shrub :herbaceous :ground :root :vine]}))

(defonce site-state
  (r/atom {:online true
           :location-enabled false
           :location nil
           :compass {:enabled false
                     :map {:rotation false}
                     :rotation 0}
           ;; used so we can disable things like key capture on input boxes
           :diagram-focus false
           :global-events true
           :datalog-queries {}
           :notifications []
           :auth nil
           :current-form {}
           :modal {:visible false
                   :body [:div "missing"]}
           :site {:show-sidebar false}}))

#_(defonce site-state-watch
    (add-watch site-state
               :site-state-watcher
               (fn [key atom old-state new-state] (prn "site state modified" key)
                 #_(prn (clojure.data/diff old-state new-state)))))

(defonce app-state
  (r/atom
   {:debug nil
    ;:tool nil
    :selected nil
    :user-plant-lists []
    :search-filters {:type :sub-canopy}
    :diagram {:settings {:values  {:width "20"
                                   :diagram.settings/geo-location [5.505 51.505]}}
              :info {:visible false}}
    :visual {:names :common
             :units :ft}
    :current {:plant nil
              :geo-position [0 0]
              :mode :select}

    :canvas {:zoom 0.5 :pos [0 0]
             :width 600
             :height 600
             :view {:width 300
                    :height 300}
             :settings true}
    :mouse {:pos []
            :button {:state :up :pos []}
            :start-time nil
            :dragging nil
            ;:tool nil
            :multi :one
            :history []}}))

(defn store-pointer-history [point]
  ;; don't store history when we don't need to it complicate things
  (case (-> @app-state :mouse :multi)
    :one (when (= 1 (-> @app-state :mouse :history count))
           (swap! app-state assoc-in [:mouse :history] []))
    :two (when (= 2 (-> @app-state :mouse :history count))
           (swap! app-state update-in [:mouse :history] #(-> % rest vec)))
    :many nil)
  #_(when  (false? (-> @app-state :mouse :multi))
      (when (= 1 (-> @app-state :mouse :history count))
        (swap! app-state assoc-in [:mouse :history] [])))
  (swap! app-state update-in [:mouse :history] #(conj % point)))

(defn reset-selected-plant
  "Reset selected plant, also reset current form as it may have a loaded plant"
  [& _]
  (swap! site-state assoc-in [:current-form] nil)
  (swap! app-state assoc-in [:plant] {}))


(defn reset-pointer []
  (prn "reset pointer")
  (swap! app-state assoc-in [:touch ] {} )
  #_(swap! app-state assoc-in [:touch :start :time] 0)
  #_(swap! app-state assoc-in [:touch :start :coords] nil)
  #_(swap! app-state assoc-in [:touch :start :point] nil))

(defn reset-mouse []
  (swap! app-state assoc :mouse
         (merge (-> @app-state :mouse)
                {:button {:state :up}
                 :start-time nil
;                 :tool nil
                 :multi :one
                 :dragging nil
                 :history []})))

(defn reset-input-capture []
  (reset-mouse)
  (reset-pointer))

(defn set-mode
  "MODE is something like :insert :move :select
   TOOL is the plant type :canopy :vine :shrub etc"
  ([mode] (set-mode mode nil))
  ([mode tool]

   (reset-input-capture)
   (when mode
     (swap! app-state assoc-in [:selected :tool] tool)
     (swap! app-state assoc :mode mode)
     (swap! app-state assoc :tool tool))

   (when tool
     (swap! app-state assoc :tool tool)
     (swap! app-state assoc-in [:mouse :tool] tool)
     (swap! app-state assoc-in [:mouse :multi]
            (or (get-in tools [tool :multi]) :one)))))

(defn reset-editing []
  (prn "reset editing")
  (reset-mouse)
  (set-mode :select)
  (swap! app-state assoc-in [:selected :eid] nil)
  (swap! app-state assoc-in [:diagram :info :visible] false)
  (swap! app-state assoc :selected nil))

(defn js-round [num]
  (/ (.round js/Math (* (+ num (.-EPSILON js/Number))) 1000) 1000))

(defn update-scales []
  (swap! app-state assoc-in [:canvas :scale :distance]  (* 2 (/ 4 (-> @app-state :canvas  :zoom))))
  (swap! app-state assoc-in [:canvas :scale :font] (/ 1 (-> @app-state :canvas :zoom))))

(defn update-zoom
  [dir]
  (if (= dir :inc)
    (swap! app-state update-in [:canvas :zoom] (fn [current-zoom] (+ current-zoom (* current-zoom 0.5))))
    (swap! app-state update-in [:canvas :zoom] (fn [current-zoom] (- current-zoom (* current-zoom 0.5)))))
  (update-scales)
  #_(swap! app-state assoc-in [:canvas :scale :distance]  (* 2 (/ 10 (-> @app-state :canvas  :zoom))))
  #_(swap! app-state assoc-in [:canvas :scale :font] (/ 1 (-> @app-state :canvas :zoom))))

;; 15
;; 0.2 zoomed out

 ;; (/ 1 0.2)
 ;; (/ 2 0.2)
 ;; (/ 2 15)

#_((defn zoom-canvas [zoom]
                                        ;(swap! app-state assoc-in [:canvas :scale :font] (/ 3 zoom))
     (swap! app-state assoc-in [:canvas :scale :font] (/ 1 zoom))
     (swap! app-state assoc-in [:canvas :zoom]
            (+ (-> @app-state :canvas :zoom) (js-round zoom)))))

(defn svg-transform
  ([]
   (str
    "scale("
    (-> @app-state :canvas :zoom) ","
    (-> @app-state :canvas :zoom) ")"
    "translate("
    (-> @app-state :canvas :pos first) ","
    (-> @app-state :canvas :pos second) ")"
    "rotate("
    (-> @site-state :compass :rotation) ")"))
  ([{:keys [zoom pos rotate]}]
   (str
    (when zoom 
      (str "scale("
           zoom ","
           zoom ")"))
    (when pos 
      (str "translate("
           (first pos) ","
           (second pos) ")"))
    (when rotate 
      (str "rotate(" rotate ")")))))

#_(defn svg-canvas-viewbox []
  (str (points->str [(* -1 (/ (-> @app-state :canvas :view :width) 2))
                     (* -1 (/ (-> @app-state :canvas :view :height) 2))])  " "
       (points->str [(-> @app-state :canvas :view :width)
                     (-> @app-state :canvas :view :height)])))

(defn move-canvas [x y]
  (swap! app-state assoc-in [:canvas :pos] [x y]))

(defn pan-canvas [x y]
  (prn "pan " (-> @app-state :canvas :pos))
  (swap! app-state assoc-in [:canvas :pos]
         [(+ #_(* (-> @app-state :canvas :zoom) x) (* 10 x) (-> @app-state :canvas :pos first))
          (+ #_(* (-> @app-state :canvas :zoom) y) (* 10 y) (-> @app-state :canvas :pos second))]))

(defn toggle-debug []
  (swap! app-state update :debug not))

(defn toggle-sidebar
  ([] (toggle-sidebar (-> @site-state :show-sidebar not)))
  ([state]
   (swap! site-state assoc :show-sidebar  (-> @site-state :show-sidebar not))))

(defn toggle-modal
  ([] (toggle-modal (-> @site-state :modal :visible not)))
  ([state]
   (swap! site-state assoc-in [:modal :visible] state)
   (swap! site-state assoc-in [:global-events] (not state))))

(defn hide-modal []
  (toggle-modal false))

(defn configure-modal [title body]
  (toggle-modal)
  (swap! site-state assoc-in [:modal]
         {:title title
          :visible true
          :body body}))

(defn authed?
  "Return true if we have auth data"
  []
  (-> @site-state :auth :access_token some?))

(defn polyculture?
  "Check if this is the diagram page"
  []
  (= :polyculture (-> @site-page :current-route :data :name)))

(defn diagram?
  "Check if this is the diagram page"
  []
  (= :diagram (-> @site-page :current-route :data :name)))

(defn homepage?
  "Check if this is the homepage page"
  []
  (= :homepage   (-> @site-page :current-route :data :name)))

(defn default-units [] (-> @app-state :visual :units))
(defn reset-selection []
  (prn "reset selection")
  (swap! app-state assoc :selected nil))

(defn diagram-settings
  "Given no param's return the current state, if :show is provided then set show state any other value set hide state"
  ([] (-> @app-state :canvas :settings))
  ([state]
   (if (= state :show)
     (do (swap! site-state assoc :global-events false)
         (swap! app-state assoc-in [:canvas :settings] true))
     (do (swap! app-state assoc-in [:canvas :settings] false)
         (swap! site-state assoc :global-events true)))))

(defn compass-rotation []
  (-> @site-state :compass :rotation)
  #_(if (-> @site-state :compass-enabled) (-> @site-state :compass) (-> @site-state :compass)))

(defn reset-compass [evt]
  (.preventDefault evt)
  (swap! site-state assoc [:compass :rotation] 0))

(defn toggle-compass [evt]
  (.preventDefault evt)
  (swap! site-state update-in [:compass :enabled] not))

(defn toggle-compass-map-rotate [evt]
  (.preventDefault evt)
  (swap! site-state update-in [:compass :map :rotate] not))

(defn initial-app-state
  "Sets any initial value & Calls any functions to calculate inital values"
  []
  (update-scales))

(defonce set-initial-state (initial-app-state))
;; Delayed to allow the atom to be populated
(def build-api-url (delay (partial str (-> @app-state :config :backend-api-root))))

(comment
  (hide-modal)
  (toggle-modal)
  @site-state
  (-> @site-state :selected)
  (-> @app-state :selected)
  (configure-modal "abc" "123")
  (swap! site-state assoc-in [:global-events] true)
  (swap! app-state assoc-in [:test] true)
  (swap! app-state assoc-in [:test] false)

  ;; whole page is rerendered when site-state is changed
  (swap! site-state assoc :test true)
  (swap! site-state assoc :test false)

  (swap! site-page assoc-in [:test] true)
  (swap! site-page assoc-in [:test] false)

  (swap! site-state update :modal assoc :title "test")
  (swap! site-state update :modal assoc :title "test2")
  (swap! site-state assoc-in [:modal :visible] true)
  (swap! site-state assoc-in [:modal :visible] false)
  (-> @site-page :current-route :data :name))

